import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PortalLogin from "@/pages/PortalLogin";
import DesignStudio from "@/pages/DesignStudio";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AutoLogin from "@/pages/AutoLogin";
import SEOHead from "@/components/SEOHead";

const RequirePortal = ({ children }) => {
  const { portalToken } = useAuth();
  return portalToken ? children : <Navigate to="/" replace />;
};

const RequireAdmin = ({ children }) => {
  const { adminToken } = useAuth();
  const location = useLocation();
  return adminToken ? children : <Navigate to="/admin" replace state={{ from: location.pathname + location.search }} />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SEOHead />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PortalLogin />} />
            <Route path="/s/:token" element={<AutoLogin />} />
            <Route path="/studio" element={<RequirePortal><DesignStudio /></RequirePortal>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
